/* AO Trade application form (sections/ao-trade-apply.liquid), 30 Oct 2026.
   Validates in the browser (plain-English inline errors, first bad field focused), then POSTs JSON to the
   AO Trade app through the app proxy (/apps/ao-trade/apply):
     { firstName, lastName, businessName, businessType, email, phone, vatNumber,
       address: { address1, address2, city, provinceCode, zip }, website, message, marketingOptIn,
       company_url (honeypot), elapsedMs (render -> submit) }
   Answers: {ok:true,status:'received'} / {ok:true,status:'already_trade'} / 400 {error:'invalid',fields:[...]} /
   429 / anything else (including a 404 while the endpoint isn't deployed) -> WhatsApp fallback. */
(function () {
  'use strict';
  var form = document.querySelector('[data-ao-apply]');
  if (!form) return;
  var t0 = Date.now();
  var card = form.closest('.ao-tapply__card') || form.parentNode;
  var alertBox = card.querySelector('[data-ao-apply-alert]');
  var done = card.querySelector('[data-ao-apply-done]');
  var btn = form.querySelector('[data-ao-apply-submit]');
  var busy = false;

  var LABEL = {
    firstName: 'First name', lastName: 'Last name', email: 'Email', phone: 'Phone (WhatsApp)', businessName: 'Business name',
    businessType: 'Business type', vatNumber: 'VAT number', website: 'Website or Instagram', address1: 'Address line 1',
    address2: 'Address line 2', city: 'City or town', provinceCode: 'Province', zip: 'Postal code', message: 'Message'
  };
  var REQUIRED_MSG = {
    firstName: 'Enter your first name.', lastName: 'Enter your last name.', email: 'Enter your email address.',
    phone: 'Enter a phone number we can WhatsApp.', businessName: 'Enter your business name.', businessType: 'Choose your type of business.',
    address1: 'Enter the street address.', city: 'Enter the city or town.', provinceCode: 'Choose a province.', zip: 'Enter the postal code.'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function field(name) { return form.elements[name]; }
  function val(name) { var f = field(name); return f ? String(f.value || '').trim() : ''; }

  function setError(name, msg) {
    var f = field(name); if (!f) return;
    var e = document.getElementById('AoApply-' + name + '-err');
    f.setAttribute('aria-invalid', 'true');
    if (e) { e.textContent = msg; e.hidden = false; }
  }
  function clearErrors() {
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid]'), function (f) { f.removeAttribute('aria-invalid'); });
    Array.prototype.forEach.call(form.querySelectorAll('.ao-tapply__err'), function (e) { e.textContent = ''; e.hidden = true; });
    alertBox.hidden = true; alertBox.innerHTML = '';
  }
  function showAlert(html, focus) {
    alertBox.innerHTML = html; alertBox.hidden = false;
    if (focus) alertBox.focus();
  }

  function validate() {
    var bad = [];
    Object.keys(REQUIRED_MSG).forEach(function (n) { if (!val(n)) { setError(n, REQUIRED_MSG[n]); bad.push(n); } });
    if (val('email') && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) { setError('email', 'Enter an email address like name@business.co.za.'); bad.push('email'); }
    var digits = val('phone').replace(/\D/g, '');
    if (val('phone') && (digits.length < 9 || digits.length > 13)) { setError('phone', 'Enter a phone number with the area or mobile code, e.g. 082 123 4567.'); bad.push('phone'); }
    if (val('zip') && !/^\d{4}$/.test(val('zip'))) { setError('zip', 'A South African postal code has 4 digits.'); bad.push('zip'); }
    return bad;
  }

  function summary(names, intro) {
    var uniq = names.filter(function (n, i) { return names.indexOf(n) === i; });
    return '<p>' + intro + '</p><ul>' + uniq.map(function (n) { return '<li><a href="#AoApply-' + esc(n) + '">' + esc(LABEL[n] || n) + '</a></li>'; }).join('') + '</ul>';
  }
  function focusFirst(names) { for (var i = 0; i < names.length; i++) { var f = field(names[i]); if (f) { f.focus(); return; } } }

  // The app may name a field "address.city" or "city": both point at the same input.
  function fieldName(n) { n = String(n || ''); return n.indexOf('address.') === 0 ? n.slice(8) : n; }

  function waLink() {
    var u = form.getAttribute('data-wa');
    return u ? ' <a href="' + esc(u) + '" target="_blank" rel="noopener">WhatsApp us</a>' : ' WhatsApp us';
  }

  function finish(html) {
    form.hidden = true;
    alertBox.hidden = true;
    done.innerHTML = html;
    done.hidden = false;
    done.focus();
    var top = card.getBoundingClientRect().top;
    if (top < 0) card.scrollIntoView({ block: 'start' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    clearErrors();
    var bad = validate();
    if (bad.length) {
      showAlert(summary(bad, 'Please check ' + (bad.length === 1 ? 'this field' : 'these ' + bad.length + ' fields') + ':'), false);
      focusFirst(bad);
      return;
    }
    var body = {
      firstName: val('firstName'), lastName: val('lastName'), businessName: val('businessName'), businessType: val('businessType'),
      email: val('email'), phone: val('phone'), vatNumber: val('vatNumber'),
      address: { address1: val('address1'), address2: val('address2'), city: val('city'), provinceCode: val('provinceCode'), zip: val('zip') },
      website: val('website'), message: val('message'),
      marketingOptIn: !!(field('marketingOptIn') && field('marketingOptIn').checked),
      company_url: field('company_url') ? field('company_url').value : '',
      elapsedMs: Date.now() - t0
    };
    busy = true;
    btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    fetch(form.getAttribute('data-endpoint') || '/apps/ao-trade/apply', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (x) {} return { status: r.status, j: j && typeof j === 'object' ? j : {} }; });
    }, function () { return { status: 0, j: {} }; }).then(function (res) {
      busy = false;
      btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      var j = res.j;
      if (j.ok && j.status === 'received') {
        finish('<p><b>Thanks — we’ve received your application.</b> Daniel will be in touch within 2 working days.</p>');
        return;
      }
      if (j.ok && j.status === 'already_trade') {
        finish('<p>You already have a trade account — <a href="' + esc(form.getAttribute('data-login') || '/account/login') + '">log in</a> to see trade prices.</p>');
        return;
      }
      if (res.status === 400 && j.error === 'invalid' && Array.isArray(j.fields) && j.fields.length) {
        var names = j.fields.map(fieldName).filter(function (n) { return !!field(n); });
        names.forEach(function (n) { setError(n, 'Please check this ' + (LABEL[n] ? LABEL[n].toLowerCase() : 'field') + '.'); });
        if (names.length) { showAlert(summary(names, 'Please check ' + (names.length === 1 ? 'this field' : 'these fields') + ':'), false); focusFirst(names); return; }
      }
      if (res.status === 429) { showAlert('<p>Too many attempts. Please try again in a few minutes.</p>', true); return; }
      showAlert('<p>Something went wrong and your application didn’t reach us.' + waLink() + ' and we’ll set you up.</p>', true);
    });
  });
})();
